import React, { Fragment } from 'react';
import BootstrapModal from '../Modal';
import RecurveUtility from '../../../functions/utility';

const ItemAddedPopup = function(props) {
    let closeFunction = () => {
        document.location = document.referrer;
    }

    let proceedFunction = () => {
        let cartHref = `${RecurveUtility.relativeURI()}/cart`;
        document.location = cartHref;
    }

    let bodyContent = (
    <Fragment>
        <h3>Congratulations!</h3>
        <p>You have sucessfully {window.editLineID ? 'updated' : 'added'} <strong>{props.itemBaseName}</strong> {window.editLineID ? '.' : 'to your cart.'}</p>
    </Fragment>);
    
    return (
        <BootstrapModal proceedText="Proceed to Cart" closeText='Return to Menu' bodyContent={bodyContent} title={window.editLineID ? "Item Updated" : "Item Added To Cart"} closeFunction={closeFunction} proceedFunction={proceedFunction} />
    );
};

export default ItemAddedPopup;